import { gql, useQuery } from "@apollo/client";

const GET_MEMBER_EXCLUSIONS = gql`
  query getMemberExclusions($memberId: ID!) {
    account {
      id
      member(id: $memberId) {
        id
        excludedVenues {
          id
          venueId
          reason
          connectionId
        }
      }
    }
  }
`;

export const useMemberExclusions = memberId => {
  const { data, loading, error, refetch } = useQuery(GET_MEMBER_EXCLUSIONS, {
    variables: { memberId },
    fetchPolicy: "network-only",
    skip: !memberId
  });

  return {
    excludedVenues: data?.account?.member?.excludedVenues || [],
    loading,
    error,
    refetch: () => refetch()
  };
};
